<template>
  <div>
    <Title :pages="[{ icon: 'circle', page: page_title.toUpperCase() }]"></Title>

    <v-container fluid>
      <v-btn color="primary" class="mb-5" dark @click="updateDialog(true)">Crear {{ modal_title }}</v-btn>

      <v-btn class="ml-3 mb-5 text-white" color="blue-grey" @click="dialog_bulk = true">Importar Proveedores</v-btn>

      <Modal
        v-if="create_access"
        :modal_title="modal_title"
        :formBtn="formBtn"
        :dialog="dialog"
        :parent="parent"
        :service="service"
        @updateDialog="updateDialog"
        @loadList="loadList(service)"
        :item="mainItem"
        @updateItem="
          (newItem) => {
            mainItem = newItem;
          }
        "
      />

      <ModalBulk
        v-if="create_access"
        modal_title="Importar Proveedores"
        :service="service"
        :formBtn="formBtn"
        :dialog="dialog_bulk"
        :mainItem="mainItem"
        @open="dialog_bulk = true"
        @close="dialog_bulk = false"
        @filter="loadList(service)"
      />

      <ModalInitialBalance
        :parent="parent"
        :modal_title="$t('Saldo inicial de') + ' ' + mainItem.name"
        :dialog="dialog_initial_balance"
        :item="mainItem"
        button_name="Saldo inicial"
        :formBtn="formBtn"
        :section="Constant.SECTION_SUPPLIERS"
        @updateDialog="updateDialog"
        @loadList="loadList(service)"
        @closeModal="closeModalInitialBalance"
      />

      <v-card>
        <div class="row mb-5 mt-0">
          <div class="col-md-12" v-if="list_access">
            <div class="col-md-12" style="background:white; elevation-0">
              <div class="row pt-6">
                <div class="col-md-4 pt-0">
                  <v-radio-group
                    v-model="selected_status"
                    row
                    class="mt-0 mb-0"
                    @change="
                      $store.commit('setFilterSupplier', {
                        selected_status: selected_status,
                      })
                    "
                  >
                    <v-radio label="Habilitado" :value="true"></v-radio>
                    <v-radio label="No habilitado" :value="false"></v-radio>
                    <v-radio label="Todos" value="all"></v-radio>
                  </v-radio-group>
                </div>
                <div class="col-md-3 pt-0">
                  <v-combobox
                    v-model="supplier_type_selected"
                    autocomplete="off"
                    data-vv-as="supplier_type_selected"
                    name="supplier_type_selected"
                    item-text="name"
                    item-value="id"
                    :items="supplier_types"
                    label="Tipo"
                    class="pt-0 mt-0"
                    clearable
                    @change="
                      $store.commit('setFilterSupplier', {
                        supplier_type_selected: supplier_type_selected,
                      })
                    "
                    @clear="$store.commit('setFilterSupplier', { supplier_type_selected: null })"
                  ></v-combobox>
                </div>

                <div class="col-md-5 pt-0" style="display: flex; justify-content: end">
                  <v-btn color="info" class="" @click="filter">Buscar</v-btn>
                </div>
              </div>
            </div>
          </div>
        </div>
      </v-card>

      <v-card v-if="list_access">
        <v-card-title>
          <span class="text-uppercase">{{ page_title }}</span>
          <v-spacer></v-spacer>
          <v-text-field v-model="search" append-icon="search" label="Buscar" single-line hide-details @input="updateSearch"></v-text-field>
        </v-card-title>
        <v-data-table
          :headers="headers"
          :items="list"
          :search="search"
          :loading="loading"
          loading-text="Cargando..."
          :options="{
            descending: true,
            itemsPerPage: 15,
          }"
          @pagination="updatePagination"
          :footer-props="{
            itemsPerPageOptions: [5, 10, 15, 50, -1],
          }"
          :page="update_page"
          @update:page="updatePage"
        >
          <template v-slot:item="props">
            <tr>
              <td>{{ props.item.name }}</td>
              <td>
                <span class="table-text-secondary">{{ props.item.cuit }}</span>
              </td>
              <td>{{ props.item.type_name != null ? props.item.type_name : "" }}</td>
              <td class="text-center">
                <span class="table-text-secondary">{{ props.item.external_reference }}</span>
              </td>
              <td class="text-right">
                <span :class="props.item.balance == 0 ? '' : props.item.balance > 0 ? 'bg-round-green' : 'bg-round-red'">{{ formatUtils.formatPrice(props.item.balance) }}</span>
              </td>
              <td class="text-center">
                {{ props.item.enabled ? "SI" : "NO" }}
              </td>
              <td class="text-right" style="min-width: 200px">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-icon v-if="update_access" v-on="on" small color="blue-grey" class="mr-2" @click="goToBalances(props.item)"> description </v-icon>
                  </template>
                  <span>Ver Cta. Cte.</span>
                </v-tooltip>

                <!--<v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-icon v-if="update_access" v-on="on" small color="orange" class="mr-2" @click="goToComprobantesPendientes(props.item)"> payments </v-icon>
                  </template>
                  <span>Comprobantes pendientes</span>
                </v-tooltip>-->

                <!--<v-tooltip bottom v-if="props.item.initial_balance == null">
                  <template v-slot:activator="{ on }">
                    <v-icon v-if="update_access" v-on="on" small color="purple" class="mr-2" @click="editInicialBalanceItem(props.item)"> request_quote </v-icon>
                  </template>
                  <span>Editar Saldo inicial</span>
                </v-tooltip>-->

                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-icon v-if="update_access" v-on="on" small color="blue" class="mr-2" @click="editItem(props.item)"> edit </v-icon>
                  </template>
                  <span>Editar</span>
                </v-tooltip>

                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-icon v-on="on" small color="blue" class="mr-1" @click="viewItem(props.item)"> remove_red_eye </v-icon>
                  </template>
                  <span>Ver</span>
                </v-tooltip>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-icon v-if="delete_access" v-on="on" small color="red" class="mr-2" @click="deleteItem(props.item)"> delete </v-icon>
                  </template>
                  <span>Eliminar</span>
                </v-tooltip>
              </td>
            </tr>
          </template>
          <template v-slot:no-results>
            <v-alert :value="true" color="error" icon="warning">
              {{ "Busqueda sin resultados - " + search }}
            </v-alert>
          </template>
        </v-data-table>
      </v-card>

      <DialogLoading :dialog="dialog_loading" text="Cargando..." />

      <DialogDelete :dialog_delete="dialog_delete" @updateDialogDelete="updateDialogDelete" @deleteItemConfirm="deleteItemConfirm" />
    </v-container>
  </div>
</template>

<script>
import Constant from "@/constants/sections";
import { generalService } from "@/libs/ws/generalService";
import { formatUtils } from "@/libs/utils/formatUtils";
import GenericMixin from "@/mixins/GenericMixin.vue";
import Title from "@/components/Title.vue";
import DialogDelete from "@/components/DialogDelete.vue";
import DialogLoading from "@/components/DialogLoading.vue";
import Modal from "./Modal.vue";
import ModalBulk from "./ModalBulk.vue";
import RolMixin from "@/mixins/RolMixin.vue";
import ModalInitialBalance from "@/components/ModalInitialBalance.vue";
import { suppliersService } from "../../../libs/ws/suppliersService";
export default {
  components: { Title, Modal, DialogDelete, DialogLoading, ModalInitialBalance, ModalBulk },
  mixins: [GenericMixin, RolMixin],
  data() {
    return {
      Constant: Constant,
      dialog_initial_balance: false,
      dialog_bulk: false,
      formatUtils: formatUtils,
      parent: this,
      service: suppliersService,
      page_title: "Proveedores",
      modal_title: "Proveedor",
      selected_status: this.$store.state.supplier.filter.selected_status,
      supplier_type_selected: this.$store.state.supplier.filter.supplier_type_selected,
      search: this.$store.state.supplier.filter.search,
      mainItem: {
        id: "",
        name: "",
        cuit: "",
        iva_condition: null,
        tipo_persona: null,
        telephone: "",
        email: "",
        business_name: "",
        external_reference: "",
        invoice_expiration: "30",
        address: "",
        enabled: true,
        type: null,
        provincia: null,
        impuesto_inscripto: [],
        impuesto_excento: [],
        supplier_banks: [],
      },
      defaultItem: null,
      headers: [
        {
          text: "Nombre",
          align: "left",
          sortable: true,
          value: "name",
        },
        {
          text: "CUIT",
          align: "left",
          sortable: true,
          value: "cuit",
        },
        {
          text: "Tipo",
          align: "left",
          sortable: true,
          value: "type_name",
        },
        { text: "Id. Externo", value: "external_reference", align: "center" },

        { text: "Saldo Acumulado", value: "balance", align: "center" },
        { text: "Habilitado", value: "enabled", align: "center" },
        { text: "Accion", value: "", align: "center" },
      ],
      list: [],
      dialog_delete: false,
      update_page: 1,
      supplier_types: [],
      dialog_loading: false,
    };
  },
  mounted() {
    this.defaultItem = JSON.parse(JSON.stringify(this.mainItem));
    // this.service.setSection(Constant.SECTION_SUPPLIERS);
    this.loadList(this.service);
    this.loadSupplierTypes();
  },
  methods: {
    //El listado trae filas planas: para los modales se pide el objeto completo por id
    async requestSupplier(id) {
      try {
        const response = await this.service.get(id);
        if (response.status === true) return response.result;
        this.$toast.error(response.msg, "Error");
      } catch (e) {
        console.log("suppliersService.get error");
        console.log(e);
        this.$toast.error("Error al obtener el proveedor", "Error");
      }
      return null;
    },
    async fetchSupplier(id) {
      this.dialog_loading = true;
      const supplier = await this.requestSupplier(id);
      this.dialog_loading = false;
      return supplier;
    },
    //Sobrescriben GenericMixin: la fila del listado no alcanza para el modal
    async viewItem(item) {
      await this.openSupplierModal(item, false);
    },
    async editItem(item) {
      this.errors.clear();
      await this.openSupplierModal(item, true);
    },
    async openSupplierModal(item, is_edit) {
      const supplier = await this.fetchSupplier(item.id);
      if (supplier == null) return;

      const index = this.list.indexOf(item);
      this.editedIndex = is_edit ? index : -1;
      this.viewdIndex = is_edit ? -1 : index;
      this.mainItem = supplier;
      this.dialog = true;
    },
    updateSearch(value) {
      this.search = value;
      this.$store.commit("setFilterSupplier", { search: value });
    },
    updatePage(page) {
      this.$store.commit("setCurrentPageSupplier", page);
      this.update_page = page;
    },
    loadList(service, param = null) {
      this.loading = true;

      if (param == null) {
        param = this.getFilterParams();
      }

      this.open_filter = false;
      service
        .filter(param)
        .then((response) => {
          if (this.$store.state.supplier.pagination.page > 1) {
            this.update_page = this.$store.state.supplier.pagination.page;
          }

          this.list = response.result;
          this.loading = false;

          if (typeof this.selected !== "undefined") {
            this.selected = [];
          }
        })
        .catch((e) => {
          console.log("service.filter error");
          console.log(e);
          this.loading = false;
        });
    },
    goToComprobantesPendientes(item) {
      this.$router.push("/reports/supplier/pending-vouchers/" + item.id);
    },
    deleteItemConfirm() {
      this.delete(this.service);
      this.dialog_delete = false;
      this.loadList(this.service);
    },
    goToBalances(item) {
      this.$router.push(Constant.SECTION_SUPPLIERS_BALANCES + "/" + item.id);
    },
    editInicialBalanceItem(item) {
      this.errors.clear();
      this.editedIndex = this.list.indexOf(item);
      this.mainItem = Object.assign({}, item);
      this.dialog_initial_balance = true;
    },
    closeModalInitialBalance() {
      this.dialog_initial_balance = false;
    },
    filter() {
      this.loadList(this.service, this.getFilterParams());
    },
    getFilterParams() {
      const param = {
        raw: true, //El listado se resuelve por SQL: filas planas, sin objetos de Doctrine
        enabled: this.selected_status,
        type: this.supplier_type_selected != null ? this.supplier_type_selected.id : null,
      };
      return param;
    },
    loadSupplierTypes() {
      generalService.setSection(Constant.SECTION_SUPPLIER_TYPE);
      generalService
        .filter()
        .then((response) => {
          this.supplier_types = response.result;
        })
        .catch((e) => {
          console.log("supplier_types.filter error");
          console.log(e);
        });
    },
  },
};

// TODO agregar un boton de limpiar busqueda.
</script>
